import React, { useState } from "react";
import CardActualizacionMasiva from "../../../General/Excel/CardActualizacionMasiva";
import {
  leerExcelPublicaciones,
  leerExcelPublicacionesPorCodigo,
  postExcelPublicacionesModerador,
} from "../../../../api/axios";
import { toast } from '../../../../utilities/appToast';
import PropTypes from 'prop-types';

export default function ActualizacionMasivaPrecioYStock({ idSeller, userType, idUsuario }) {
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [checkboxesSeller] = useState({
    stock: true,
    precioLista: true,
    precioPromocional: true,
  });

  const isValidUpdateExcel = () => {
    if (!file) {
      toast.warn("No se ha seleccionado ningún archivo CSV.");
      return false;
    }
    return true;
  };
  const toDecimalOrNull = (v) => {
    if (v === null || v === undefined || v === "") return null;
    if (typeof v === "number") return v;
    const n = Number(String(v).trim().replace(",", "."));
    return Number.isNaN(n) ? null : n;
  };

  const toIntOrNull = (v) => {
    if (v === null || v === undefined || v === "") return null;
    if (typeof v === "number") return Number.parseInt(v, 10);
    const n = Number(String(v).trim().replace(",", "."));
    return Number.isNaN(n) ? null : Number.parseInt(n, 10);
  };
  const buildPayloadPorCodigo = (listaExcel = []) => {
    const listaElementos = listaExcel
      .map((item) => {
        const skuValue = String(
          item?.skuMarket ??
            item?.SkuMarket ??
            item?.skuSeller ??
            item?.SkuSeller ??
            item?.skuMegatone ??
            item?.SkuMegatone ??
            ""
        ).trim();
        return {
          skuMarket: skuValue,
          precioLista: toDecimalOrNull(item.precioLista ?? item?.PrecioLista),
          precioPromocional: toDecimalOrNull(item.precioPromocional ?? item?.PrecioPromocional),
          stock: toIntOrNull(item.stock ?? item?.Stock),
        };
      })
      .filter((item) => item.skuMarket !== "");

    return {
      idSeller,
      listaElementos,
    };
  };

  const mostrarMensajesLectura = (data) => {
    if (!data) return false;
    if (typeof data === "string") {
      if (data === "Archivo con formato incorrecto") {
        toast.error(data);
      } else if (data.toUpperCase().startsWith("ERROR")) {
        toast.error("Error al leer el archivo. Verificá encabezados y formato del CSV.");
      }
      return true;
    }
    if (data === "Archivo con formato incorrecto") {
      toast.error(data);
      return true;
    }
    if (data.error && (data.error === "no se importó" || data.error === "no se importo")) {
      toast.error(`${data.mensaje ?? "No se importó"} ${data.skuSellerFallo ?? ""}`.trim());
      toast.warn(
        "Revisá el CSV: cada fila debe tener SKU y al menos un valor numerico valido en Precio Lista, Mega Oferta o Stock."
      );
    }
    if (data.error === "") {
      toast.success(data.mensaje ?? "Archivo leído correctamente");
    }
    return Boolean(data.fallaronTodos);
  };

  const leerExcelConFallback = async (formData, primaryReader, secondaryReader) => {
    const first = await primaryReader(formData);
    const firstData = first?.data;
    const firstHasRows = Array.isArray(firstData?.listaExcel) && firstData.listaExcel.length > 0;
    const firstIsHardError = typeof firstData === "string" && firstData.toUpperCase().startsWith("ERROR");
    if (firstHasRows || !secondaryReader || !firstIsHardError) return first;
    return secondaryReader(formData);
  };

  const llamarActualizacionMasiva = async (payload) => {
    try {
      const res = await postExcelPublicacionesModerador(payload);
      const errores = res?.data?.errores;
      if (Array.isArray(errores) && errores.length) {
        errores.forEach((e) => toast.warn(e));
      } else {
        toast.success("Publicaciones actualizadas");
      }
    } catch (err) {
      const data = err?.response?.data;
      const errs = data?.errores ?? data?.errors;

      if (Array.isArray(errs) && errs.length) {
        errs.forEach((e) => {
          if (typeof e === "string") toast.warn(e);
          else toast.warn(`${e?.target ?? "Campo"}: ${e?.message ?? e?.error ?? "Error"}`);
        });
        toast.success("Actualización realizada (con errores).");
        return;
      }

      toast.error(`Error al guardar: ${err?.message ?? "desconocido"}`);
    }
  };

  const exportExcel = async () => {
    if (!isValidUpdateExcel()) return;

        setIsLoading(true);
        try {
            const oData = new FormData();
            oData.append("filename", String(file.name));
            oData.append("filedata", file);

      const isSellerOrAdmin =
        userType?.isSellerAdmin || userType?.isSeller || userType?.isAdmin || userType?.isAdminMod;
      const isSellerUser = userType?.isSellerAdmin || userType?.isSeller;

      if (isSellerOrAdmin) {
        const { stock, precioLista, precioPromocional } = checkboxesSeller;
        oData.append("idSeller", String(idSeller ?? ""));
        oData.append("ch_stock", String(Boolean(stock)));
        oData.append("ch_precioLista", String(Boolean(precioLista)));
        oData.append("ch_precioPromocional", String(Boolean(precioPromocional)));

        const res1 = isSellerUser
          ? await leerExcelConFallback(
              oData,
              leerExcelPublicacionesPorCodigo,
              leerExcelPublicaciones
            )
          : await leerExcelConFallback(
              oData,
              leerExcelPublicaciones,
              leerExcelPublicacionesPorCodigo
            );
        const cortar = mostrarMensajesLectura(res1?.data);
        if (cortar) return;

        const listaExcel = res1?.data?.listaExcel ?? [];
        if (!Array.isArray(listaExcel) || !listaExcel.length) {
          toast.warn("El archivo no contiene filas válidas para procesar.");
          return;
        }

        const payload = buildPayloadPorCodigo(listaExcel);
        await llamarActualizacionMasiva(payload);
      } else {
        const res1 = await leerExcelConFallback(
          oData,
          leerExcelPublicacionesPorCodigo,
          leerExcelPublicaciones
        );
        const cortar = mostrarMensajesLectura(res1?.data);
        if (cortar) return;

        const listaExcel = res1?.data?.listaExcel ?? [];
        if (!Array.isArray(listaExcel) || !listaExcel.length) {
          toast.warn("El archivo no contiene filas válidas para procesar.");
          return;
        }

                const payload = buildPayloadPorCodigo(listaExcel);
                await llamarActualizacionMasiva(payload);
            }
        } catch (error) {
            console.error("Error en ActualizacionMasivaPrecioYStock.exportExcel:", error);
            toast.error("Error al leer archivo");
        } finally {
            setIsLoading(false);
        }
    };

  return (
    <div className="card p-4">
      <CardActualizacionMasiva
        title="Precios y Stock"
        btnText="Actualizar Precios y Stock"
        updateFile={setFile}
        isLoading={isLoading}
        exportExcel={exportExcel}
        tipoExcel={1}
        isValidUpdateExcel={isValidUpdateExcel}
        downloadName="Modelo Actualización Precio-Stock"
      >
      </CardActualizacionMasiva>
    </div>
  );
}
ActualizacionMasivaPrecioYStock.propTypes = {
    idUsuario: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    idSeller: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    userType: PropTypes.shape({
        isAdminMod: PropTypes.bool,
        isSeller: PropTypes.bool,
        isSellerAdmin: PropTypes.bool,
        isAdmin: PropTypes.bool
    })
}